import { useEffect, useState } from "react";
import { useTranslation } from 'next-i18next';
import styles from './BusinessDivisionDesktop.module.scss';
import { BusinessDivisionItem } from "./BusinessDivisionItem";
import { useRouter } from "next/router";

export const BusinessDivisionDesktop = () => {
    const { t } = useTranslation();
    const router = useRouter();
    const [hoverState, setHoverState] = useState('default');
    const [showCard, setShowCard] = useState(false);

    const getJourneyInfo = () => {
        if (hoverState === 'default') {
            return { title: '', subtitle: '' };
        }

        return {
            title: t(`businessDivision.${hoverState}Title`),
            subtitle: t(`businessDivision.${hoverState}Text`),
        };
    }

    const activeCard = (journey) => {
        setShowCard(true);
        setHoverState(journey);
    }

    const handleClickDivisionDetailsButton = (division) => {
        router.push(`/${router.query.locale}/business-division/${division}`);
    }

    return (
        <div className={styles.container} id="who-we-are">
            <div className={styles.line}></div>
            <div className={styles.title}>{t('businessDivision.title')}</div>
            <div className={styles.text}>{t('businessDivision.text')}</div>
            <div className={styles.journeys}>
                <BusinessDivisionItem journey={"acceleration"} hoverstate={hoverState} setHoverState={activeCard} />
                <BusinessDivisionItem journey={"disruption"} hoverstate={hoverState} setHoverState={activeCard} />
                <BusinessDivisionItem journey={"expansion"} hoverstate={hoverState} setHoverState={activeCard} />
            </div>
            {showCard &&
                <div className={styles.card_know_more_wrapper}>
                    <div
                        className={styles.card_know_more}>
                        <div className={styles.card_text}>
                            <div className={styles.card_title}>{getJourneyInfo(hoverState).title}</div>
                            <div className={styles.card_subtitle}>{getJourneyInfo(hoverState).subtitle}</div>
                        </div>
                        <button
                            className={`${styles.card_button} ${styles[`card_button_${hoverState}`]}`}
                            onClick={() => handleClickDivisionDetailsButton(hoverState)}
                        >{t('businessDivision.knowMore')}</button>
                    </div>
                </div>}
        </div>
    )
}